module.exports = __webpack_public_path__ + "media/images/city/033-teotihuacan-15d4dafc83c1b9ea2062ca194ef193ad.svg";